import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Switch = () => {
    return (
        <Accordion disableGutters>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel10-content"
                id="panel10-header"
            >
                How to switch or change accounts?
            </AccordionSummary>
            <AccordionDetails>
                <Typography sx={{ fontSize: "14px" }}>
                    To switch between multiple accounts, you can just simply click on your brand on
                    Dashboard page or on the brand bar in the product page in header section, where
                    by clicking on the brand bar it will open up a list of created brands that you
                    can switch between.
                </Typography>
            </AccordionDetails>
        </Accordion>
    );
};

export default Switch;
